<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="23.5" height="23.5" viewBox="0 0 23.5 23.5" class="el-icon">
		<path
			d="M22.5,20.808A1.692,1.692,0,0,1,20.808,22.5H2.192A1.692,1.692,0,0,1,.5,20.808V7.963A1.692,1.692,0,0,1,.991,6.778L6.778.991A1.692,1.692,0,0,1,7.963.5H20.808A1.692,1.692,0,0,1,22.5,2.192Z"
			transform="translate(0.25 0.25)"
			fill="none"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.5"
		/>
		<path
			d="M14.511,17.658V9.416a1,1,0,0,0-.23-.648.735.735,0,0,0-.556-.268H4.286a.735.735,0,0,0-.556.268,1,1,0,0,0-.23.648v8.242"
			transform="translate(2.745 5.092)"
			fill="none"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.5"
		/>
		<path
			d="M14.658.5V6.91a.916.916,0,0,1-.916.916H6.416A.916.916,0,0,1,5.5,6.91V.5"
			transform="translate(3.276 0.25)"
			fill="none"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.5"
		/>
	</svg>
</template>

<script>
export default {
	name: 'saveIcon',
	data() {
		return {};
	},
	props: {
		color: {
			type: String,
			default: '#fff',
		},
	},
};
</script>
